(() => {
  const normalize = value => String(value || '').normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[’'.,&()\-]/g, ' ').replace(/\s+/g, ' ').trim();

  function initialize(section) {
    if (section.dataset.searchReady) return;
    const search = section.querySelector('[data-route-search]');
    const empty = section.querySelector('[data-route-empty]');
    const data = section.querySelector('[data-route-countries]');
    if (!search || !empty || !data) return;
    const countries = new Map(JSON.parse(data.textContent).map(country => [country.code, country]));
    const cards = [...section.querySelectorAll('[data-route]')].map(card => {
      const country = countries.get(card.dataset.countryCode);
      return {
        card,
        english: normalize(country?.en || card.dataset.name),
        terms: [card.dataset.name, card.dataset.countryCode, country?.en, country?.zhHant, country?.zhHans, country?.title, ...(country?.aliases || [])].map(normalize).filter(Boolean)
      };
    });
    const buttons = [...section.querySelectorAll('.hkgr__tabs button')];
    let region = buttons.find(button => button.classList.contains('active'))?.dataset.region || 'all';
    let composing = false;

    function apply() {
      if (composing) return;
      const query = normalize(search.value);
      const initial = /^[a-z]$/.test(query);
      let shown = 0;
      cards.forEach(({card, english, terms}) => {
        const okRegion = region === 'all' || card.dataset.region === region;
        const okSearch = !query || (initial ? english.startsWith(query) : terms.some(term => term.includes(query)));
        card.hidden = !(okRegion && okSearch);
        if (!card.hidden) shown++;
      });
      empty.hidden = shown !== 0;
    }

    search.addEventListener('input', apply);
    search.addEventListener('search', apply);
    search.addEventListener('compositionstart', () => {composing = true;});
    search.addEventListener('compositionend', () => {composing = false; apply();});
    buttons.forEach(button => {
      button.type = 'button';
      button.setAttribute('aria-pressed', String(button.dataset.region === region));
      button.addEventListener('click', () => {
        region = button.dataset.region;
        buttons.forEach(item => {
          const active = item === button;
          item.classList.toggle('active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        apply();
      });
    });
    section.dataset.searchReady = 'true';
    apply();
  }

  function scan(root) {
    if (root.matches?.('[data-hkg-route-directory]')) initialize(root);
    root.querySelectorAll('[data-hkg-route-directory]').forEach(initialize);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(document), {once: true});
  else scan(document);
  document.addEventListener('shopify:section:load', event => scan(event.target));
})();
